import { IContact } from 'models';
import { Moment } from 'moment';

export enum ExpenseAction {
  Invoice = 'Invoice',
}

export interface IExpense {
  key: number;
  id: string;
  // id_shift?: string;
  idShift?: string;
  category: string;
  idCategory: string;
  payee: string;
  description: string;
  date: Moment;
  amount: number;
  payment_method: string;
  expenseType: ExpenseType;
  businessExpenseType: BusinessExpenseType;
  idContact?: string;
  contact?: IContact;
  attachments?: any[];
  amountExclGst: number;
  amountInclGst: number;
  amountGst: number;
  expanded: boolean;
  idInvoice?: number;
}

export enum ExpenseType {
  Business = 'Business',
  Reclaimable = 'Reclaimable',

  // Not persistent
  All = 'All types',
}

export enum BusinessExpenseType {
  Capital = 'Capital',
  General = 'General',
}

export enum ExpenseCategories {
  AccountingLegalFees = '1',
  AdvertisingAndMarketingCosts = '2',
  BankCharges = '3',
  BusinessMotorVehicleExpenses = '4',
  ComputerSubscriptions = '5',
  EducationAndTraining = '6',
  EquipmentRentals = '7',
  Gifts = '8',
  HomeOfficeExpenses = '9',
  Insurance = '10',
  InterestPaid = '11',
  LaundryCharges = '12',
  MealsAndEntertainment = '13',
  OfficeSuppliesAndExpenses = '14',
  ProfessionalMemberships = '15',
  TravelExpenses = '16',
  Other = '17',
}

export function ExpenseCategoriesToText(value: string | undefined): string | undefined {
  switch (value) {
    case ExpenseCategories.AccountingLegalFees:
      return 'Accounting/Legal fees';
    case ExpenseCategories.AdvertisingAndMarketingCosts:
      return 'Advertising and marketing costs';
    case ExpenseCategories.BankCharges:
      return 'Bank charges';
    case ExpenseCategories.BusinessMotorVehicleExpenses:
      return 'Business motor vehicle expenses';
    case ExpenseCategories.ComputerSubscriptions:
      return 'Computer Subscriptions';
    case ExpenseCategories.EducationAndTraining:
      return 'Education and training';
    case ExpenseCategories.EquipmentRentals:
      return 'Equipment rentals';
    case ExpenseCategories.Gifts:
      return 'Gifts';
    case ExpenseCategories.HomeOfficeExpenses:
      return 'Home office expenses';
    case ExpenseCategories.Insurance:
      return 'Insurance';
    case ExpenseCategories.InterestPaid:
      return 'Interest paid';
    case ExpenseCategories.LaundryCharges:
      return 'Laundry charges';
    case ExpenseCategories.MealsAndEntertainment:
      return 'Meals and Entertainment';
    case ExpenseCategories.OfficeSuppliesAndExpenses:
      return 'Office supplies and expenses';
    case ExpenseCategories.ProfessionalMemberships:
      return 'Professional memberships';
    case ExpenseCategories.TravelExpenses:
      return 'Travel expenses';
    case ExpenseCategories.Other:
      return 'Other';
    default:
      return undefined;
  }
}

// TODO: Delete it soon!
export const ExpenseCategoriesOptions = [
  { key: ExpenseCategories.AccountingLegalFees, value: ExpenseCategories.AccountingLegalFees, label: 'Accounting/Legal fees' },
  { key: ExpenseCategories.AdvertisingAndMarketingCosts, value: ExpenseCategories.AdvertisingAndMarketingCosts, label: 'Advertising and marketing costs' },
  { key: ExpenseCategories.BankCharges, value: ExpenseCategories.BankCharges, label: 'Bank charges' },
  { key: ExpenseCategories.BusinessMotorVehicleExpenses, value: ExpenseCategories.BusinessMotorVehicleExpenses, label: 'Business motor vehicle expenses' },
  { key: ExpenseCategories.ComputerSubscriptions, value: ExpenseCategories.ComputerSubscriptions, label: 'Computer Subscriptions' },
  { key: ExpenseCategories.EducationAndTraining, value: ExpenseCategories.EducationAndTraining, label: 'Education and training' },
  { key: ExpenseCategories.EquipmentRentals, value: ExpenseCategories.EquipmentRentals, label: 'Equipment rentals' },
  { key: ExpenseCategories.Gifts, value: ExpenseCategories.Gifts, label: 'Gifts' },
  { key: ExpenseCategories.HomeOfficeExpenses, value: ExpenseCategories.HomeOfficeExpenses, label: 'Home office expenses' },
  { key: ExpenseCategories.Insurance, value: ExpenseCategories.Insurance, label: 'Insurance' },
  { key: ExpenseCategories.InterestPaid, value: ExpenseCategories.InterestPaid, label: 'Interest paid' },
  { key: ExpenseCategories.LaundryCharges, value: ExpenseCategories.LaundryCharges, label: 'Laundry charges' },
  { key: ExpenseCategories.MealsAndEntertainment, value: ExpenseCategories.MealsAndEntertainment, label: 'Meals and Entertainment' },
  { key: ExpenseCategories.OfficeSuppliesAndExpenses, value: ExpenseCategories.OfficeSuppliesAndExpenses, label: 'Office supplies and expenses' },
  { key: ExpenseCategories.ProfessionalMemberships, value: ExpenseCategories.ProfessionalMemberships, label: 'Professional memberships' },
  { key: ExpenseCategories.TravelExpenses, value: ExpenseCategories.TravelExpenses, label: 'Travel expenses' },
  { key: ExpenseCategories.Other, value: ExpenseCategories.Other, label: 'Other' },
];
